import api from './apiClient'
import { setItem, getItem, removeItem } from '@/utils/storage'

const TOKEN_KEY = 'token'
const USER_KEY = 'user'

export default {
  // 🔑 LOGIN
  async login(payload) {
    const res = await api.post('/auth/login', payload)

    const { token, user } = res.data.data

    setItem(TOKEN_KEY, token)
    setItem(USER_KEY, user)

    return res.data
  },

  async acceptInvite(payload) {
    const res = await api.post('/auth/accept-invite', payload)
    return res.data
  },


  async forgotPassword(payload) {
    const res = await api.post('/auth/forgot-password', payload)
    return res.data
  },
  
  async resetPassword(payload) {
    const res = await api.post('/auth/reset-password', payload)
    return res.data
  },
  
  // 🚪 LOGOUT
  logout() {
    removeItem(TOKEN_KEY)
    removeItem(USER_KEY)
  },

  // 📦 HELPERS
  getToken() {
    return getItem(TOKEN_KEY)
  },

  getUser() {
    return getItem(USER_KEY)
  },

  isAuthenticated() {
    return !!getItem(TOKEN_KEY)
  }
}